const CommentLoader = () => {
  return ( 
    <p>Loading comment...</p>
  );
}
 
export default CommentLoader;